import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";

import { DateCell } from "~/shared/ui/TableV2";

const DATE_OPTIONS = ["startDate", "endDate"];

export const getContestTerritoriesColumns = (
  t: TFunction,
  options: string[],
): ColumnsType<any> =>
  options.map((option) => ({
    title: t(`contestTerritories.table.${option}`),
    dataIndex: option,
    key: option,
    render: (value: any) => {
      if (option === "status") {
        return <span>{t(`contestTerritories.status.${value}`)}</span>;
      }
      if (DATE_OPTIONS.includes(option)) {
        return value ? (
          <DateCell date={value} formatString="dd.MM.yyyy" />
        ) : (
          <span>{value}</span>
        );
      }
      return <span>{value}</span>;
    },
  }));
